import { Component } from "react";
import Window from "../ui/Window";
import { Box, Stack } from "@mui/material";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
import { MdOutlineTroubleshoot, MdOutlineVerified } from "react-icons/md";
import BuscaInventario from "../ui/BuscaInventario";
import { httpPost } from "../util/http";
import ApuracaoFicha from "../ui/ApuracaoFicha";
import ApuracaoControls from "../ui/ApuracaoControls";
import ApuracaoEmailDialog from "../ui/ApuracaoEmailDialog";
import MessageDialog from "../ui/MessageDialog";
import { gerarFin } from "../util/apuracaoCalc.js";
import ApuracaoEmailSucessoDialog from "../ui/ApuracaoEmailSucessoDialog.jsx";

export default class Apuracao extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
        this.state = {
            loading: false,
            apurando: false,
            show: false,
            emailDialogOpen: false,
            apuracao: {},
            periodo: {},
            ajustes: {},
            buscaId: 0,
            emailErr: false,
            showEmailSucessDial: false
        }
    }

    onSearch = (periodo) => {
        this.setState(prev => ({
            show: true,
            loading: true,
            periodo,
            apuracao: {},
            ajustes: {},
            buscaId: prev.buscaId + 1 // força atualização
        }));

        httpPost('/apuracao/buscar', {
            inventarioId: periodo.inventario_id,
            inventarioAvariaId: periodo.inventario_avaria_id,
            periodo: periodo.nome,
        },

            data => {
                let apuracao = data?.apuracao || {};

                console.log(apuracao)

                let ajustes = {
                    principal: apuracao.principal?.ajuste || null,
                    avaria: apuracao.avaria?.ajuste || null,
                    ajustesManuais: apuracao.ajustesManuais?.ajuste || null,
                    ajustesFornecedor: apuracao.ajustesFornecedor?.ajuste || null,
                    ajustesSemanais: apuracao.ajustesSemanais?.ajuste || null,
                };

                this.setState({ apuracao, loading: false, ajustes });
            },

            error => {
                this.setState({ show: false, loading: false });
                console.error(error);
            },

            false
        );
    }

    sendEmail = (info) => {
        this.setState({ emailErr: false });
        httpPost('/apuracao/sendmail', {
            info
        },
            data => {
                this.setState({ emailDialogOpen: false, showEmailSucessDial: true });
            },

            error => {
                this.setState({ emailErr: true });
                console.error(error);
            },

            false
        );
    }

    onReset = () => {
        this.setState({ show: false });
    }

    // chamado pelo ApuracaoFicha toda vez que um painel aplica ou remove (null) um ajuste
    onAjustarPainel = (chave, ajuste) => {
        this.setState(prev => ({
            ajustes: { ...prev.ajustes, [chave]: ajuste }
        }));
    }

    onApurarClick = () => {
        let { apuracao, ajustes, periodo } = this.state;

        let ajustesFornecedor = apuracao?.ajustesFornecedor;
        let ajustesManuais = apuracao?.ajustesManuais;
        let ajustesSemanais = apuracao?.ajustesSemanais;
        let avaria = apuracao?.avaria;
        let depositos = apuracao?.depositos;
        let diferencas = apuracao?.diferencas;
        let info = apuracao?.info;
        let itensAjustados = apuracao?.itensAjustados;
        let principal = apuracao?.principal;
        let vendas = apuracao?.vendas;
        let nf = apuracao?.nf;

        let finPrincipal = gerarFin(principal, ajustes.principal);
        let finAvaria = gerarFin(avaria, ajustes.avaria);
        let finManuais = gerarFin(ajustesManuais, ajustes.ajustesManuais);
        let finFornecedor = gerarFin(ajustesFornecedor, ajustes.ajustesFornecedor);
        let finSemanais = gerarFin(ajustesSemanais, ajustes.ajustesSemanais);

        let dados = {
            periodo: periodo.nome,
            invt_duracao_ini: info?.duracaoInt,
            invt_duracao_fin: info?.duracaoInt,

            prin_falt_qtd_ini: principal?.faltas?.itens,
            prin_falt_vlr_ini: principal?.faltas?.valor,
            prin_falt_qtd_fin: finPrincipal.faltQtdFin,
            prin_falt_vlr_fin: finPrincipal.faltVlrFin,
            prin_sobr_qtd_ini: principal?.sobras?.itens,
            prin_sobr_vlr_ini: principal?.sobras?.valor,
            prin_sobr_qtd_fin: finPrincipal.sobrQtdFin,
            prin_sobr_vlr_fin: finPrincipal.sobrVlrFin,
            prin_justicativa: finPrincipal.justificativa,

            avar_falt_qtd_ini: avaria?.faltas?.itens,
            avar_falt_vlr_ini: avaria?.faltas?.valor,
            avar_falt_qtd_fin: finAvaria.faltQtdFin,
            avar_falt_vlr_fin: finAvaria.faltVlrFin,
            avar_sobr_qtd_ini: avaria?.sobras?.itens,
            avar_sobr_vlr_ini: avaria?.sobras?.valor,
            avar_sobr_qtd_fin: finAvaria.sobrQtdFin,
            avar_sobr_vlr_fin: finAvaria.sobrVlrFin,
            avar_justicativa: finAvaria.justificativa,

            manu_falt_qtd_ini: ajustesManuais?.faltas?.itens,
            manu_falt_vlr_ini: ajustesManuais?.faltas?.valor,
            manu_falt_qtd_fin: finManuais.faltQtdFin,
            manu_falt_vlr_fin: finManuais.faltVlrFin,
            manu_sobr_qtd_ini: ajustesManuais?.sobras?.itens,
            manu_sobr_vlr_ini: ajustesManuais?.sobras?.valor,
            manu_sobr_qtd_fin: finManuais.sobrQtdFin,
            manu_sobr_vlr_fin: finManuais.sobrVlrFin,
            manu_justicativa: finManuais.justificativa,

            forn_falt_qtd_ini: ajustesFornecedor?.faltas?.itens,
            forn_falt_vlr_ini: ajustesFornecedor?.faltas?.valor,
            forn_falt_qtd_fin: finFornecedor.faltQtdFin,
            forn_falt_vlr_fin: finFornecedor.faltVlrFin,
            forn_sobr_qtd_ini: ajustesFornecedor?.sobras?.itens,
            forn_sobr_vlr_ini: ajustesFornecedor?.sobras?.valor,
            forn_sobr_qtd_fin: finFornecedor.sobrQtdFin,
            forn_sobr_vlr_fin: finFornecedor.sobrVlrFin,
            forn_justicativa: finFornecedor.justificativa,

            sema_falt_qtd_ini: ajustesSemanais?.faltas?.itens,
            sema_falt_vlr_ini: ajustesSemanais?.faltas?.valor,
            sema_falt_qtd_fin: finSemanais.faltQtdFin,
            sema_falt_vlr_fin: finSemanais.faltVlrFin,
            sema_sobr_qtd_ini: ajustesSemanais?.sobras?.itens,
            sema_sobr_vlr_ini: ajustesSemanais?.sobras?.valor,
            sema_sobr_qtd_fin: finSemanais.sobrQtdFin,
            sema_sobr_vlr_fin: finSemanais.sobrVlrFin,
            sema_justicativa: finSemanais.justificativa,

            nf_perdas: nf,

            totl_dif_meta: diferencas?.meta,
            itns_ajust_meta: itensAjustados?.metaTotal,
            avar_vlr_now_meta: depositos?.meta,
            invt_duracao_meta: info.meta,

            avar_vlr_now: depositos?.avaria,
            segr_vlr_now: depositos?.segregado,
            divr_vlr_now: depositos?.divergencias,
            como_vlr_now: depositos?.comodato,

            avar_vend_vlr: vendas?.avaria?.venda,
            avar_cust_vlr: vendas?.avaria?.custo,
            segr_vend_vlr: vendas?.segregado?.venda,
            segr_cust_vlr: vendas?.segregado?.custo,
        };

        this.setState({ apurando: true });

        httpPost('/apuracao/apurar', {
            inventarioId: apuracao.inventario_id,
            dados
        },

            () => {
                this.state.apuracao.fechada = true
                this.setState({ apurando: false, apuracao: apuracao, showApuracaoSucess: true });
            },

            error => {
                this.setState({ apurando: false });
                console.error(error);
            },

            false
        );
    }

    onSendEmailClick = () => {
        this.setState({ emailDialogOpen: true });
    }

    render() {
        let { apuracao, loading, show, apurando, emailDialogOpen,
            periodo, showApuracaoSucess, ajustes, buscaId, emailErr,
            showEmailSucessDial
        } = this.state;
        let inicio = periodo?.nome ? periodo.nome.split(' a ')[0] : '--\--\--';
        let final = periodo?.nome ? periodo.nome.split(' a ')[1] : '--\--\--';
        return (
            <>
                {this.user.isAdmin &&
                    <Window full title="Apuração de Inventário" icon={MdOutlineTroubleshoot}>
                        <Box mt={2.5} pr={1} sx={{ overflowY: 'auto' }} height="100%">
                            <Stack gap={2}>
                                {showEmailSucessDial && <ApuracaoEmailSucessoDialog onClose={() => this.setState({ showEmailSucessDial: false })} />}
                                {showApuracaoSucess &&
                                    <MessageDialog onClose={() => this.setState({ showApuracaoSucess: false })}><Stack direction="row"><Box color="green" mr={1}><MdOutlineVerified size={20} /></Box>Apuração concluída com sucesso!</Stack></MessageDialog>}
                                {emailDialogOpen &&
                                    <ApuracaoEmailDialog
                                        error={emailErr}
                                        assunto={"Apuração de Inventário - " + periodo?.unidade?.nome}
                                        corpo={"Segue em anexo o relatório de apuração do período " + periodo?.nome + "."}
                                        uuid={periodo?.uuid}
                                        onClose={() => this.setState({ emailDialogOpen: false })}
                                        onEnviar={this.sendEmail}
                                    />
                                }
                                <BuscaInventario onSearch={this.onSearch} onReset={this.onReset} loading={loading} />
                                {show &&
                                    <Stack gap={2}>
                                        <ApuracaoFicha key={buscaId} inicio={inicio} final={final} apuracao={apuracao} ajustes={ajustes} loading={loading} onAjustarPainel={this.onAjustarPainel} />
                                        <ApuracaoControls
                                            apurado={apuracao.fechada}
                                            user={this.user} onPdfClick={() => window.open(process.env.REACT_APP_API_URL + '/apuracao/relatorio/' + periodo?.uuid, '_blank')}
                                            onApurarClick={this.onApurarClick}
                                            onSendEmailClick={this.onSendEmailClick}
                                            loading={apurando} />
                                        <Box mt={2} />
                                    </Stack>
                                }
                            </Stack>
                        </Box>
                    </Window>
                }
                {this.state.toHome && <Navigate to='/' />}
            </>
        );
    }
}
